import { render, staticRenderFns } from "./UnifiedClientDashboard.vue?vue&type=template&id=35a9bd71&scoped=true&"
import script from "./UnifiedClientDashboard.vue?vue&type=script&lang=js&"
export * from "./UnifiedClientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedClientDashboard.vue?vue&type=style&index=0&id=35a9bd71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9bd71",
  null
  
)

export default component.exports